import { isNumeric } from 'helpers/miscUtils';
import { strToBoolean } from 'helpers/queryUtils';
import { isBoolean, isString, isNumber } from 'lodash';
import { z } from 'zod';

export const intSchema = z.preprocess(
  (val) => Number(val),
  z.number().int().nonnegative()
);

export const numberSchema = z.preprocess(
  (val) => (isNumeric(val) ? Number(val) : val),
  z.number().optional()
);

export const booleanSchema = z.preprocess(
  (val) => (isBoolean(val) || isString(val) ? strToBoolean(val) : undefined),
  z.boolean().optional()
);

export const dateSchema = z.preprocess(
  (val) =>
    val instanceof Date
      ? val
      : val === null
        ? null
        : isNumber(val) || isString(val)
          ? new Date(val)
          : undefined,
  z.date().or(z.null()).optional()
);

/**
 * A date that is always present — unlike {@link dateSchema}, which is optional
 * and nullable because it serves query filters and the legacy meeting columns
 * that genuinely may be absent.
 *
 * Worth the second schema: typing a value that cannot be null as nullable pushes
 * a check into every render path that reads it, and the check can only ever be
 * dead code.
 */
export const requiredDateSchema = z.preprocess(
  (val) => (isNumber(val) || isString(val) ? new Date(val) : val),
  z.date()
);

export const urlSchema = z.preprocess((val) => {
  if (typeof val !== 'string') return val;
  const trimmed = val.trim();
  return trimmed === '' ? undefined : trimmed;
}, z.string().url('Must be a valid URL').optional());
